import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitLabaratoryResearchDetails = ({
  labaratoryResearches,
  laboratoryResearchesRef,
  handleFileDownload,
}) => {
  console.log('VisitLabaratoryResearchDetails');
  if (!Array.isArray(labaratoryResearches) || labaratoryResearches.length === 0)
    return null;

  return (
    <div ref={laboratoryResearchesRef}>
      {labaratoryResearches.map((research, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">
              Laboratorinis tyrimas
            </Heading>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {new Date(Date.parse(research.orderDate)).getUTCHours() ===
                0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(research.orderDate)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(research.orderDate)}
                  </Moment>
                )}
              </span>
            </div>

            <div>
              <span>Pavadinimas: </span>
              <span>{research.name}</span>
            </div>

            <div>
              <span>Būsena: </span>
              <span>{research.statusDisplay}</span>
            </div>

            <div>
              <span>Gydytojas: </span>
              <span>{research.requestedDoctorNameSurname}</span>
            </div>

            <div className="font-medium mt-2">Rezultatai:</div>

            {(!research.observations || research.observations.length === 0) && (
              <div>-</div>
            )}

            {research.observations?.map((result, idx) => (
              <div key={idx} className="space-y-1">
                <div>
                  <span>Pavadinimas: </span>
                  <span>{result.name}</span>
                </div>

                {result.referenceRange && (
                  <div>
                    <span>Norma: </span>
                    <span>{result.referenceRange}</span>
                  </div>
                )}

                <div>
                  <span>Rezultatas: </span>
                  <span>{result.value}</span>
                </div>

                <div>
                  <span>Matavimo vienetas: </span>
                  <span>{result.unit}</span>
                </div>
              </div>
            ))}

            {research.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${research.name} ${moment(
                      new Date(research.date),
                    ).format('YYYY-MM-DD')}`;
                    handleFileDownload(
                      'LabaratoryResearch',
                      fileName,
                      research.file.type,
                      research.file.guid,
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>
          <CardFooter />
        </Card>
      ))}
    </div>
  );
};
